import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class DistinctareaApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'distinctarea'
    }


    /** 获取行政机构信息列表
     * @returns
     */
    public getEntities(){
        return this.send({},"getListAll",Methods.GET);
    }

    /**
     * 查询数据分页列表
     * @param params
     */
    public getListPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET)
    }

}